import AxiosInstance from '../config/AxiosInstance';

export interface Product {
    id: string;
    sku: string;
    type: number;
    productName: string;
    productGroup: { groupName: string };
    updatedAt: Date;
    isActive: boolean;
}

export interface ProductAttributesPayload {
    productId: string;
    position: number;
}

export interface ReasonPayload {
    companyId: string,
    reasonType: number,
    reasonName: string,
    reasonDescription: string,
    impactType: number,
    updatedAt: Date,
    isActive: boolean,
}

const createReason = async (payload: ReasonPayload[], type: number) => {
    try {
        const { data } = await AxiosInstance.put(`/api/inventory/reasons/update/${type}`, payload);
        return { data };
    } catch (error) {
        throw error;
    }
}

const getAllReasonsWithOutType = async () => {
    try {
        const { data } = await AxiosInstance.get(`/api/inventory/reasons/find-all`);
        return { data };
    } catch (error) {
        throw error;
    }
}

const getDetailReasons = async (companyId: string, reasonType: string) => {
    try {
        const { data } = await AxiosInstance.get(`/api/inventory/reasons/findOne/${reasonType}`);
        return { data };
    } catch (error) {
        throw error;
    }
}


const getListReasons = async (companyId: string, page: string, limit: number) => {
    try {
        const { data } = await AxiosInstance.get(`/api/inventory/reasons/list`, {
            params: {
                page: page,
                limit: limit,
            }
        });
        return { data };
    } catch (error) {
        throw error;
    }
}

export {
    createReason,
    getListReasons,
    getDetailReasons,
    getAllReasonsWithOutType
}